"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
function view() {
    var _this = this;
    return {
        state: {
            showMobileMap: false,
            allowedTags: ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "blockquote", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr"]
        },
        initialize: function () {
            _this.props.initMethod();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
            if (!document.getElementById('skip-to-main-content')) {
                var skipText = csod.locales.get('Skip to Main Content', 'Skip to Main Content');
                var hiddenStyle = 'position:absolute;left:-9999px;top:auto;width:1px;height:1px;overflow:hidden;z-index:10000;';
                var getVisibleStyle = function () {
                    var bgColor = (csod.viewModel && csod.viewModel.headerData && csod.viewModel.headerData.color) || '#005a9e';
                    return 'position:fixed;top:0;left:0;width:auto;height:auto;padding:10px 15px;background:' + bgColor + ';color:#fff;font-size:16px;font-weight:bold;text-decoration:none;z-index:10000;outline:2px solid #fff;';
                };
                var skipLink = document.createElement('a');
                skipLink.id = 'skip-to-main-content';
                skipLink.href = 'javascript:void(0)';
                skipLink.setAttribute('role', 'link');
                skipLink.setAttribute('aria-label', skipText);
                skipLink.textContent = skipText;
                skipLink.style.cssText = hiddenStyle;
                skipLink.addEventListener('focus', function () { this.style.cssText = getVisibleStyle(); });
                skipLink.addEventListener('blur', function () { this.style.cssText = hiddenStyle; });
                skipLink.addEventListener('click', function (e) {
                    e.preventDefault();
                    var heading = document.getElementById('resultsHeaderText') || document.querySelector('[data-tag="ResultsHeaderText"]');
                    if (heading) {
                        heading.setAttribute('tabindex', '-1');
                        var themeColor = (csod.viewModel && csod.viewModel.headerData && csod.viewModel.headerData.color) || '#005a9e';
                        heading.setAttribute('style', 'outline:2px solid ' + themeColor + ' !important;outline-offset:2px !important;');
                        heading.addEventListener('blur', function handler() {
                            this.removeAttribute('style');
                            this.removeEventListener('blur', handler);
                        });
                        heading.focus();
                    }
                });
                skipLink.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.click();
                    }
                });
                document.body.insertBefore(skipLink, document.body.firstChild);
            }
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onSearchClick: this.props.onSearchClick,
            onLocationSearch: this.props.onLocationSearch,
            onLocationSearchChange: this.props.onLocationSearchChange,
            onLocationSearchPredict: this.props.onLocationSearchPredict,
            onLocationSearchSelect: this.props.onLocationSearchSelect,
            onKeywordSearch: this.props.onKeywordSearch,
            onKeywordSearchChange: this.props.onKeywordSearchChange,
            onKeywordSearchPredict: this.props.onKeywordSearchPredict,
            onKeywordSearchSelect: this.props.onKeywordSearchSelect,
            onCreateJobAlert: this.props.onCreateJobAlert,
            onSortSelect: this.props.onSortSelect,
            onSortOpen: this.props.onSortOpen,
            onInfoWindowClick: this.props.onInfoWindowClick,
            toggleMapForMobile: function () {
                _this.view.state.showMobileMap = !_this.view.state.showMobileMap;
            },
            onPageNavigate: this.props.onPageNavigate,
            handleCollapsibleClick: this.props.handleCollapsibleClick,
            onRadioButtonClick: this.props.onRadioButtonClick,
            onCheckboxClick: this.props.onCheckboxClick,
            onInputChange: this.props.onInputChange,
            onDropdownSelect: this.props.onDropdownSelect,
            onShowMobileChecked: this.props.onShowMobileChecked,
            onResetFilters: this.props.onResetFilters,
            onFilterApply: this.props.onFilterApply,
            onFilterCancel: this.props.onFilterCancel,
            onOpenFilterFlyout: this.props.onOpenFilterFlyout,
            onImagesLoaded: this.props.onImagesLoaded,
            setBannerContentHeight: this.props.setBannerContentHeight,
            onCloseJobAlertModal: this.props.onCloseJobAlertModal,
            onJobAlertTitleChange: this.props.onJobAlertTitleChange,
            onJobAlertFrequencyChange: this.props.onJobAlertFrequencyChange,
            onCreateJobAlertBtnClick: this.props.onCreateJobAlertBtnClick,
            onCancelJobAlertCreation: this.props.onCancelJobAlertCreation,
            onCFMainSearchDropdownChange: this.props.onCFMainSearchDropdownChange,
            onFilterFlagCloseClick: this.props.onFilterFlagCloseClick,
            onCloseEmailValidationErrorModal: this.props.onCloseEmailValidationErrorModal,
            onCloseFilterValidationErrorModal: this.props.onCloseFilterValidationErrorModal
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobSearch/View.js
// module id = 473
// module chunks = 0